import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Certificate } from 'crypto-pro';
import { CryptoSignError, CryptoSignService, SignedCommandT } from '@core/services/crypto-sign.service';

export type SignControlDataT = {
    description: string;
    command: {
        command_type: string;
        device_ids: string[];
        management: any;
    };
};

@Component({
    selector: 'app-sign-control',
    templateUrl: './sign-control.component.html',
    styleUrls: ['./sign-control.component.less']
})
export class SignControlComponent implements OnInit {
    certificates: Certificate[] = [];
    thumbprint: string | null = null;
    loading = false;
    signing = false;
    errorKey: string | null = null;
    errorDetail: string | null = null;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: SignControlDataT,
        private readonly dialogRef: MatDialogRef<SignControlComponent, SignedCommandT | null>,
        private readonly cryptoSign: CryptoSignService
    ) {}

    ngOnInit(): void {
        this.loadCertificates(false);
    }

    async loadCertificates(refresh: boolean) {
        this.loading = true;
        this.errorKey = null;
        this.errorDetail = null;
        try {
            this.certificates = await this.cryptoSign.getCertificates(refresh);
            if (!this.certificates.some((c) => c.thumbprint === this.thumbprint)) {
                this.thumbprint = this.certificates.length === 1 ? this.certificates[0].thumbprint : null;
            }
            if (!this.certificates.length) {
                this.errorKey = 'no_certificates';
            }
        } catch (error) {
            this.errorKey = (error as CryptoSignError).key ?? 'unknown';
            this.errorDetail = (error as Error)?.message ?? null;
        } finally {
            this.loading = false;
        }
    }

    async sign() {
        if (!this.thumbprint || this.signing) {
            return;
        }
        this.signing = true;
        this.errorKey = null;
        this.errorDetail = null;
        try {
            const signed = await this.cryptoSign.signCommand(this.thumbprint, this.data.command);
            this.dialogRef.close(signed);
        } catch (error) {
            this.errorKey = (error as CryptoSignError).key ?? 'unknown';
            this.errorDetail = (error as Error)?.message ?? null;
        } finally {
            this.signing = false;
        }
    }

    cancel() {
        this.dialogRef.close(null);
    }
}
